async function deriveKey(secret, salt) {
  const encoder = new TextEncoder();

  // Encode secret and salt
  const keyMaterial = await crypto?.subtle?.importKey(
    "raw",
    encoder.encode(btoa(secret)),  // Base64 encode like PHP
    { name: "PBKDF2" },
    false,
    ["deriveBits", "deriveKey"]
  );

  // Derive AES-256 key
  return crypto.subtle.deriveKey(
    {
      name: "PBKDF2",
      salt: encoder.encode(btoa(salt)),  // Base64 encode like PHP
      iterations: 1000,
      hash: "SHA-256"
    },
    keyMaterial,
    { name: "AES-CBC", length: 256 },
    true,
    ["decrypt"]
  );
}

function base64ToArrayBuffer(base64) {
  const binaryString = atob(base64);
  return new Uint8Array([...binaryString].map(char => char.charCodeAt(0))).buffer;
}

function hexToUint8Array(hexString) {
  return new Uint8Array(hexString.match(/.{1,2}/g).map(byte => parseInt(byte, 16)));
}

async function decryptAES(encryptedBase64) {
  const salt = "secure.payment.salt";
  const secret = "adagio.payment.secret";

  // Derive the key
  const key = await deriveKey(secret, salt);

  // Decode base64 and split IV
  const decoded = atob(encryptedBase64);
  const rawPieces = decoded.split(':');

  if (rawPieces.length !== 2) {
    throw new Error("Invalid encrypted format");
  }

  const encryptedData = base64ToArrayBuffer(rawPieces[0]);
  const iv = hexToUint8Array(rawPieces[1]);

  // Perform AES decryption
  try {
    const decrypted = await crypto.subtle.decrypt(
      { name: "AES-CBC", iv },
      key,
      encryptedData
    );
    return new TextDecoder().decode(decrypted);
  } catch (error) {
    console.error("Decryption failed:", error);
    return null;
  }
}

const decrypt = function (encrypted) {
  if (!window.crypto?.subtle) {
    console.warn("Crypto.subtle not supported for this website. Probably you running http server");
    return null;
  }
  return decryptAES(encrypted).then((result) => {
    return result;
  }).catch(console.error);
};

export default decrypt;
